(function () {
    'use strict';
    angular.module('app').component('habilSortableHeader', {
        templateUrl: '@/tableHeader/sortable-header.html',
        transclude: true,
        bindings: {
            sortKey: '@',
            sortType: '=',
            isReverse: '=',
            sorted: '&?',
        },
        controller: SortableHeaderController
    });

    SortableHeaderController.$inject = ['commonFunctions'];
    function SortableHeaderController(commonFunctions) {

        const $controller = this;

        /**
         * Propagates the changes in the binding
         * @param {Object} changes 
         */
        $controller.$onChanges = handleBindingChanges;
        $controller.$onInit = onSorted;
        /**
         * Handles a click to update the sortType
         */
        $controller.setSortType = setSortType;

        // Implementation

        function handleBindingChanges(changes) {
            if (!changes)
                return;
        }

        function setSortType() {
            
            if ($controller.sortType === $controller.sortKey)
                $controller.isReverse = !$controller.isReverse;
            else {
                $controller.sortType = $controller.sortKey;
                $controller.isReverse = false;
            }

            onSorted();
        }

        function onSorted() {
            if ($controller.sortType !== $controller.sortKey)
                return;

            if (angular.isFunction($controller.sorted)) {
                commonFunctions.invoke($controller.sorted, { key: $controller.sortType, isReverse: $controller.isReverse });
            }
        }
    }
})();